import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { set, useForm } from 'react-hook-form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createDeal, getDealById, updateDeal } from '../api/dealsApi'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import QuillResize from 'quill-resize-image'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { useDebounce } from 'use-debounce'
import { fetchSearch, fetchCompanyData } from '../api/graphApi'
import { addCategory, getCategories } from '../api/categoryApi'

// import { validateCin } from '../api/dashboardApi'

ReactQuill.Quill.register('modules/resize', QuillResize)

const AddDeals = ({ dealId = null, isEdit = false, dealType }) => {
  const [companyInfo, setCompanyInfo] = useState(false)
  const [fundRaise, setFundRaise] = useState(false)
  const [grossGraph, setGrossGraph] = useState(false)
  const navigate = useNavigate()
  const [editorContent, setEditorContent] = useState('')
  const [imagePreview, setImagePreview] = useState(null)
  const [search, setSearch] = useState('')
  const [selectedCompetitors, setSelectedCompetitors] = useState([])
  const [showNewCategory, setShowNewCategory] = useState(false)
  const [category, setCategory] = useState('')

  const queryClient = useQueryClient()

  // const [cinValidation, setCinValidation] = useState({
  //   isValidating: false,
  //   isValid: null,
  //   companyName: '',
  //   error: '',
  // })

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      companyInfoBox: false,
      fundRaiseBox: false,
      grossGraphBox: false,
      cin: '',
      cinWorld: '',
      brandName: '',
      title: '',
      articleDate: '',
      description: '',
      writtenBy: '',
      pcCredit: '',
      categoryId: '',
      image: null,
      showInSlider: false,
    },
  })

  const cinValue = watch('cin')
  const companyUniqueIdentifier = watch('cinWorld') || watch('cin')
  const brandName = watch('brandName')
  const title = watch('title')
  const articleDate = watch('articleDate')
  const writtenBy = watch('writtenBy')
  const imageFile = watch('image')

  // Check if all mandatory fields are filled
  const isFormValid = useMemo(() => {
    // const hasValidCin = cinValidation.isValid === true
    const hasBrandName = brandName?.trim().length > 0
    const hasTitle = title?.trim().length > 0
    const hasArticleDate = articleDate?.trim().length > 0
    const hasWrittenBy = writtenBy?.trim().length > 0

    console.log('hasBrandName', hasBrandName)
    console.log('hasTitle', hasTitle)
    console.log('hasArticleDate', hasArticleDate)
    console.log('hasWrittenBy', hasWrittenBy)

    const hasDescription =
      editorContent?.replace(/<[^>]*>/g, '').trim().length > 0
    const hasImage = isEdit ? true : imageFile && imageFile[0]
    console.log('hasImage', hasImage)

    return (
      // hasValidCin &&
      hasBrandName &&
      hasTitle &&
      hasArticleDate &&
      hasWrittenBy &&
      hasDescription &&
      hasImage
    )
  }, [
    // cinValidation.isValid,
    brandName,
    title,
    articleDate,
    writtenBy,
    editorContent,
    imageFile,
    isEdit,
  ])

  console.log('isFormValid', isFormValid)
  console.log()

  // // Validate CIN
  // const validateCIN = useCallback(async (cinNumber) => {
  //   if (!cinNumber || cinNumber.length !== 21) {
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: false,
  //       companyName: '',
  //       error: 'Invalid CIN format',
  //     })
  //     return
  //   }

  //   setCinValidation((prev) => ({ ...prev, isValidating: true }))

  //   try {
  //     const res = await validateCin(cinNumber)

  //     if (res?.company) {
  //       setCinValidation({
  //         isValidating: false,
  //         isValid: true,
  //         companyName: res.company,
  //         error: '',
  //       })
  //     } else {
  //       setCinValidation({
  //         isValidating: false,
  //         isValid: false,
  //         companyName: '',
  //         error: res?.error || 'CIN not found',
  //       })
  //     }
  //   } catch (error) {
  //     console.error('CIN validation error:', error)
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: false,
  //       companyName: '',
  //       error: error?.response?.data?.error || 'Error validating CIN',
  //     })
  //   }
  // }, [])

  // // Watch for CIN changes
  // useEffect(() => {
  //   if (cinValue && cinValue.length === 21) {
  //     const debounceTimer = setTimeout(() => {
  //       validateCIN(cinValue)
  //     }, 500)

  //     return () => clearTimeout(debounceTimer)
  //   } else if (cinValue && cinValue.length > 0) {
  //     setCinValidation({
  //       isValidating: false,
  //       isValid: null,
  //       companyName: '',
  //       error: '',
  //     })
  //   }
  // }, [cinValue, validateCIN])

  const [debouncedSearch] = useDebounce(search, 2000)

  // Fetch search results
  const {
    data: searchData,
    isError: isSearchError,
    isPending: isSearchPending,
    error: searchError,
  } = useQuery({
    queryKey: ['search', debouncedSearch],
    queryFn: () => fetchSearch(debouncedSearch),
    enabled: !!debouncedSearch && debouncedSearch.trim().length > 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

  // Handle adding competitor
  const addCompetitor = useCallback(
    (competitor) => {
      if (!selectedCompetitors.some((c) => c.id === competitor.id)) {
        setSelectedCompetitors((prev) => [...prev, competitor])
        setSearch('')
      }
    },
    [selectedCompetitors]
  )

  // Handle removing competitor
  const removeCompetitor = useCallback((competitorId) => {
    setSelectedCompetitors((prev) => prev.filter((c) => c.id !== competitorId))
  }, [])

  const [debouncedCin] = useDebounce(companyUniqueIdentifier, 3000) // wait 3s after typing

  const { data: companyData } = useQuery({
    queryKey: ['companyData', debouncedCin],
    queryFn: () => fetchCompanyData(debouncedCin),
    enabled: !!debouncedCin?.trim(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

  // console.log('companyData', companyData)

  // Fetch category list for dropdown
  const { data: categories, isLoading: isCategoriesLoading } = useQuery({
    queryKey: ['categories'],
    queryFn: getCategories,
  })

  // const handleAddNewCategory = (categoryName) => {
  //   if (!categoryName || categoryName.trim() === '') {
  //     toast.error('Category name is required')
  //     return
  //   }

  // console.log('Adding new category:', categoryName)
  const { mutate: handleAddNewCategory, isPending } = useMutation({
    mutationFn: addCategory,
    onSuccess: () => {
      toast.success('Category added successfully')
      queryClient.invalidateQueries(['categories'])
      setShowNewCategory(false)
      setCategory('')
    },
    onError: (error) => {
      toast.error('Failed to add category')
      console.error('Error adding category:', error)
    },
  })

  // console.log('categories', categories)

  // Fetch deal data for editing
  const { data: dealData, isLoading } = useQuery({
    queryKey: ['deals', dealId, dealType],
    queryFn: () => getDealById(dealId, dealType),
    enabled: isEdit && !!dealId,
    onError: (error) => {
      toast.error('Failed to load data')
      console.error('Error loading Deals:', error)
      navigate(`/dealdashboard/${dealType}`)
    },
  })

  // Populate form
  const populateForm = useCallback(
    (data) => {
      if (!data) {
        toast.error('No data available to populate form')
        return
      }

      setValue('title', data.title || '')
      setValue('cin', data.cin || '')
      setValue('cinWorld', data.cin || '')
      setValue('brandName', data.brandName || '')
      setValue('articleDate', data.articleDate || '')
      setValue('description', data.description || '')
      setValue('writtenBy', data.writtenBy || '')
      setValue('pcCredit', data.pcCredit || '')
      setEditorContent(data.description || '')
      setValue('categoryId', data.categoryId || '')
      setValue('showInSlider', !!data.showInSlider)

      setValue('companyInfoBox', data.companyInfoBox || false)
      setValue('fundRaiseBox', data.fundRaiseBox || false)
      setValue('grossGraphBox', data.grossGraphBox || false)

      setCompanyInfo(data.companyInfoBox || false)
      setFundRaise(data.fundRaiseBox || false)
      setGrossGraph(data.grossGraphBox || false)

      if (data.imageUrl) {
        setImagePreview(data.imageUrl)
      }

      if (data.competitor) {
        setSelectedCompetitors(data.competitor)
      }
    },
    [setValue]
  )

  // console.log('competitor', selectedCompetitors)

  useEffect(() => {
    if (isEdit && dealData) {
      populateForm(dealData)
    }
  }, [dealData, isEdit, populateForm])

  // Handle image preview
  useEffect(() => {
    if (imageFile && imageFile[0]) {
      const previewUrl = URL.createObjectURL(imageFile[0])
      setImagePreview(previewUrl)
      return () => URL.revokeObjectURL(previewUrl)
    }
  }, [imageFile])

  // Sync checkbox values with form
  useEffect(() => {
    setValue('companyInfoBox', companyInfo)
  }, [companyInfo, setValue])

  useEffect(() => {
    setValue('fundRaiseBox', fundRaise)
  }, [fundRaise, setValue])

  useEffect(() => {
    setValue('grossGraphBox', grossGraph)
  }, [grossGraph, setValue])

  // Mutations
  const createMutation = useMutation({
    mutationFn: (data) => createDeal(data, dealType),
    onSuccess: () => {
      toast.success(`${dealType} added successfully!`)
      reset()
      setImagePreview(null)
      setSelectedCompetitors([])
      navigate(`/dealdashboard/${dealType}`)
    },
    onError: (error) => {
      console.error('Error creating deal:', error)
      toast.error(
        error.response?.data?.message ||
          'Error creating deal. Please try again.'
      )
    },
  })

  const updateMutation = useMutation({
    mutationFn: (data) => updateDeal(dealId, data, dealType),
    onSuccess: () => {
      toast.success(`${dealType} updated successfully!`)
      navigate(`/dealdashboard/${dealType}`)
    },
    onError: (error) => {
      console.error('Error details:', error)
      toast.error(error.response?.data?.message || 'Failed to update Deals')
    },
  })

  const handleImageChange = useCallback(
    (e, fieldName) => {
      const files = e.target.files
      if (files && files.length > 0) {
        setValue(fieldName, files)
      }
    },
    [setValue]
  )

  const onSubmit = async (data) => {
    // if (!cinValidation.isValid) {
    //   setError('cin', {
    //     type: 'manual',
    //     message: 'Please enter a correct CIN number',
    //   })
    //   toast.error('Please enter a correct CIN number')
    //   return
    // }

    // if (!categoryId || categoryId === '') {
    //   setError('categoryId', {
    //     type: 'manual',
    //     message: 'Please select a category',
    //   })
    // }

    if (!isEdit && (!data.image || !data.image[0])) {
      toast.error('Please upload at least one image')
      return
    }

    // Add selected competitors to the data
    const submitData = {
      ...data,
      competitors: selectedCompetitors,
    }

    if (isEdit && dealId) {
      updateMutation.mutate(submitData)
    } else {
      createMutation.mutate(submitData)
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="max-w-8xl text-center mx-auto px-4 py-6">
        <p className="text-gray-600">{`Loading ${dealType} data...`}</p>
      </div>
    )
  }

  if (isSearchError) {
    toast.error(searchError.message)
  }

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    ['link', 'image', 'video', 'formula'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ direction: 'rtl' }],
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ['clean'],
    ['resize'],
  ]

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="max-w-8xl text-left mx-auto px-4 py-6">
        <div className="grid md:grid-cols-2 gap-6 mb-4">
          {/* Brand Name */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="font-semibold text-gray-800 mb-2">
              Brand Name <span className="text-red-500">*</span>
            </h2>
            <input
              type="text"
              placeholder="Enter brand name"
              {...register('brandName', {
                required: 'Brand name is required',
              })}
              className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                errors.brandName
                  ? 'border-red-500 focus:border-red-500'
                  : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
              }`}
            />
            {errors.brandName && (
              <p className="text-red-500 text-sm mt-1">
                {errors.brandName.message}
              </p>
            )}
          </div>

          {/* CIN Number */}
          {dealType !== 'world' && (
            <div className="bg-white p-6 rounded-xl shadow">
              <h2 className="font-semibold text-gray-800 mb-2">
                Company CIN Number <span className="text-red-500">*</span>
              </h2>
              <input
                type="text"
                placeholder="Enter CIN number"
                {...register('cin', {
                  required: 'CIN number is required',
                  pattern: {
                    value: /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
                    message: 'Please enter a valid CIN number format',
                  },
                })}
                className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                  errors.cin
                    ? 'border-red-500 focus:border-red-500'
                    : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                }`}
              />
              {errors.cin && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.cin.message}
                </p>
              )}

              {/* {cinValidation.isValidating && (
              <div className="flex items-center mt-2 text-blue-600">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                <span className="text-sm">Validating CIN...</span>
              </div>
            )}

            {cinValidation.isValid === true && (
              <div className="flex items-center mt-2 text-green-600">
                <svg
                  className="h-4 w-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-sm font-medium">
                  {cinValidation.companyName}
                </span>
              </div>
            )}

            {cinValidation.isValid === false && (
              <div className="flex items-center mt-2 text-red-600">
                <svg
                  className="h-4 w-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                <span className="text-sm">{cinValidation.error}</span>
              </div>
            )} */}
            </div>
          )}

          {/* CIN Number */}
          {dealType === 'world' && (
            <div className="bg-white p-6 rounded-xl shadow">
              <h2 className="font-semibold text-gray-800 mb-2">
                Company Number <span className="text-red-500">*</span>
              </h2>
              <input
                type="text"
                placeholder="Enter company number"
                {...register('cinWorld', {
                  required: 'company number is required',
                })}
                className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                  errors.cinWorld
                    ? 'border-red-500 focus:border-red-500'
                    : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                }`}
              />
              {errors.cinWorld && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.cinWorld.message}
                </p>
              )}
            </div>
          )}

          {/* Written By */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="font-semibold text-gray-800 mb-2">
              Written By <span className="text-red-500">*</span>
            </h2>
            <input
              type="text"
              placeholder="Enter name"
              {...register('writtenBy', {
                required: 'Writer Name is required',
              })}
              className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                errors.writtenBy
                  ? 'border-red-500 focus:border-red-500'
                  : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
              }`}
            />
            {errors.writtenBy && (
              <p className="text-red-500 text-sm mt-1">
                {errors.writtenBy.message}
              </p>
            )}
          </div>

          {/* Brand Logo */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="font-semibold text-gray-800 mb-2">
              Brand Logo {!isEdit && <span className="text-red-500">*</span>}
            </h2>
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Brand Logo Preview"
                className="mt-4 max-h-64 object-cover rounded-lg border border-gray-200"
              />
            )}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, 'image')}
              {...register('image', {
                required: isEdit ? false : 'Image is required',
                // validate: {
                //   fileSize: (files) => {
                //     if (files && files[0] && files[0].size > 2 * 1024 * 1024) {
                //       return 'File size must be less than 2MB'
                //     }
                //     return true
                //   },
                // },
              })}
              className="mt-3 block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-orange-50 file:text-orange-600 hover:file:bg-orange-100"
            />
            {errors.image && (
              <p className="text-red-500 text-sm mt-1">
                {errors.image.message}
              </p>
            )}
          </div>

          {/* category */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="font-semibold text-gray-800 mb-2">
              Category <span className="text-red-500">*</span>
            </h2>

            {isCategoriesLoading ? (
              <div className="flex items-center mt-2 text-blue-600">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
              </div>
            ) : (
              <>
                <select
                  {...register('categoryId', {
                    required: 'Category is required',
                  })}
                  onChange={(e) => {
                    if (e.target.value === 'new') {
                      setShowNewCategory(true)
                    } else {
                      setShowNewCategory(false)
                    }
                  }}
                  className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                    errors.categoryId
                      ? 'border-red-500 focus:border-red-500'
                      : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                  }`}
                >
                  <option value="" className="bg-slate-200">
                    Select Category
                  </option>

                  {categories?.map((category) => (
                    <option key={category?.id} value={category?.id}>
                      {category?.name}
                    </option>
                  ))}

                  <option value="new" className="bg-slate-200">
                    Add New Category
                  </option>
                </select>

                {showNewCategory && (
                  <div className="flex items-center justify-between mt-2 space-x-2 border rounded-lg border-gray-300">
                    <input
                      type="text"
                      value={category}
                      placeholder="Enter new category name"
                      onChange={(e) => setCategory(e.target.value)}
                      className="p-3 w-full text-base outline-none"
                    />

                    {isPending ? (
                      <div className="flex items-center text-blue-600">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => handleAddNewCategory(category)}
                        className="bg-orange-500 text-white p-3 rounded-lg hover:bg-orange-600"
                      >
                        Add
                      </button>
                    )}
                  </div>
                )}

                {errors.categoryId && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.categoryId.message}
                  </p>
                )}
              </>
            )}
          </div>

          {/* picture credit */}
          <div className=" bg-white/35 p-3 rounded-xl shadow">
            <div>
              <h2 className="font-semibold text-gray-800 mb-2">
                Picture Credit
              </h2>
              <input
                type="text"
                placeholder="eg : Photo by Ishant Chauhan/Hindustan Times"
                {...register('pcCredit')}
                className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                  errors.pcCredit
                    ? 'border-red-500 focus:border-red-500'
                    : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
                }`}
              />
              {errors.pcCredit && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.pcCredit.message}
                </p>
              )}
            </div>
          </div>

          {/* Heading */}
          <div className="bg-white p-6 rounded-xl shadow col-span-2">
            <h2 className="font-semibold text-gray-800 mb-2">
              Heading <span className="text-red-500">*</span>
            </h2>
            <input
              type="text"
              placeholder="Enter headline..."
              {...register('title', {
                required: 'Heading is required',
              })}
              className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                errors.title
                  ? 'border-red-500 focus:border-red-500'
                  : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
              }`}
            />
            {errors.title && (
              <p className="text-red-500 text-sm mt-1">
                {errors.title.message}
              </p>
            )}
          </div>

          {/* Content */}
          <div className="bg-white p-6 rounded-xl shadow col-span-2">
            <h2 className="font-semibold text-gray-800 mb-2">
              Content <span className="text-red-500">*</span>
            </h2>
            <ReactQuill
              theme="snow"
              value={editorContent}
              onChange={(content) => {
                setEditorContent(content)
                setValue('description', content)
              }}
              modules={{
                toolbar: toolbarOptions,
                resize: { displaySize: true },
              }}
              placeholder="Write the content here..."
              className={`${
                errors.description ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.description && (
              <p className="text-red-500 text-sm mt-1">
                {errors.description.message}
              </p>
            )}
          </div>

          {/* Article Date */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="font-semibold text-gray-800 mb-2">
              Date of Publishing <span className="text-red-500">*</span>
            </h2>
            <input
              type="date"
              {...register('articleDate', {
                required: 'Date is required',
              })}
              className={`border rounded-lg p-3 w-full text-base focus:outline-none ${
                errors.articleDate
                  ? 'border-red-500 focus:border-red-500'
                  : 'border-gray-300 focus:border-orange-500 focus:ring-orange-500'
              }`}
            />
            {errors.articleDate && (
              <p className="text-red-500 text-sm mt-1">
                {errors.articleDate.message}
              </p>
            )}
          </div>

          {/* Show in Slider */}
          <div className="bg-white p-6 rounded-xl shadow flex items-center gap-3">
            <input
              type="checkbox"
              id="showInSlider"
              {...register('showInSlider')}
              className="w-5 h-5 accent-orange-500 cursor-pointer"
            />
            <label
              htmlFor="showInSlider"
              className="font-semibold text-gray-800 cursor-pointer"
            >
              Show in Slider
              <span className="block font-normal text-sm text-gray-500">
                Adds this article to the homepage slider automatically — no
                separate slider entry needed.
              </span>
            </label>
          </div>

          {/* Search Competitor */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="font-semibold text-gray-800 mb-2">
              Add Competitor Graph
            </h2>
            <div className="relative">
              <input
                type="search"
                placeholder="Search with brand name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border rounded-lg p-3 w-full text-base focus:outline-none border-gray-300 focus:border-orange-500 focus:ring-orange-500"
              />

              {/* Search Results Dropdown */}
              {isSearchPending && search && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg p-2">
                  <div className="text-gray-500 text-sm">Searching...</div>
                </div>
              )}

              {searchData && searchData.length > 0 && search && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                  {searchData.map((brand) => (
                    <div
                      key={brand.id}
                      onClick={() => addCompetitor(brand)}
                      className="p-3 hover:bg-orange-50 cursor-pointer border-b last:border-b-0"
                    >
                      <div className="font-medium text-gray-800">
                        {brand.name}
                      </div>
                      {brand.cin && (
                        <div className="text-xs text-gray-500">{brand.cin}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Selected Competitors Tags */}
            {selectedCompetitors.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-2">
                {selectedCompetitors.map((competitor) => (
                  <div
                    key={competitor.id}
                    className="inline-flex items-center bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm"
                  >
                    <span className="mr-2">{competitor.name}</span>
                    <button
                      type="button"
                      onClick={() => removeCompetitor(competitor.id)}
                      className="hover:bg-orange-200 rounded-full p-0.5"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {companyData && (
            <div className="col-span-2">
              <div className="text-red-700 mb-4">
                Please ensure that CIN no. is correct and filled properly before
                proceeding further
              </div>

              <div className="grid gap-4">
                {companyData.companyInfo === true && (
                  <div className="bg-white p-5 rounded-xl shadow">
                    <div className="flex items-center gap-4">
                      <input
                        type="checkbox"
                        id="companyInfo"
                        checked={companyInfo}
                        onChange={() => setCompanyInfo(!companyInfo)}
                        className="w-4 h-4"
                      />
                      <label
                        htmlFor="companyInfo"
                        className="cursor-pointer text-gray-700"
                      >
                        Would you like to add Company Info Card?
                      </label>
                    </div>
                  </div>
                )}

                {companyData.grossGraph === true && (
                  <div className="bg-white p-5 rounded-xl shadow">
                    <div className="flex items-center gap-4">
                      <input
                        type="checkbox"
                        id="grossGraph"
                        checked={grossGraph}
                        onChange={() => setGrossGraph(!grossGraph)}
                        className="w-4 h-4"
                      />
                      <label
                        htmlFor="grossGraph"
                        className="cursor-pointer text-gray-700"
                      >
                        Wants to add Company's <b>Gross Graph</b>!
                      </label>
                    </div>
                  </div>
                )}

                {companyData.fundRaise === true && (
                  <div className="bg-white p-5 rounded-xl shadow">
                    <div className="flex items-center gap-4">
                      <input
                        type="checkbox"
                        id="fundRaise"
                        checked={fundRaise}
                        onChange={() => setFundRaise(!fundRaise)}
                        className="w-4 h-4"
                      />
                      <label
                        htmlFor="fundRaise"
                        className="cursor-pointer text-gray-700"
                      >
                        Add Company's <b>Fund Raise Graph</b> :)
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Submit Button */}
        <div className="mt-8 text-center">
          <button
            type="submit"
            disabled={
              !isFormValid ||
              isSubmitting ||
              createMutation.isPending ||
              updateMutation.isPending
            }
            className="bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50 text-white text-lg font-medium px-8 py-3 rounded-lg shadow-md transition-all"
          >
            {isSubmitting ||
            createMutation.isPending ||
            updateMutation.isPending
              ? 'Processing...'
              : isEdit
                ? `Update ${dealType}`
                : `Add ${dealType}`}
          </button>

          {/* Form validation status message */}
          {!isFormValid && (
            <p className="text-gray-500 text-sm mt-3">
              Please fill all mandatory fields to enable the submit button
            </p>
          )}
        </div>
      </div>
    </form>
  )
}

export default AddDeals
